var liveLandingPage = (function() {
    function init() {
        var heroUnitContainer = document.querySelector(".img-section__bg-main"),
            leftStripElem = document.querySelector('.img-section__bg-main-img--left'),
            leftStripElemHeight = leftStripElem ? leftStripElem.offsetHeight : 0,
            rightStripElem = document.querySelector('.img-section__bg-main-img--right'),
            rightStripElemHeight = rightStripElem ? rightStripElem.offsetHeight : 0,
            leftStripVal = 0,
            rightStripVal = 0;
        /**
         * Start set interval animation of BG image after page load
         */
        if (leftStripElemHeight || rightStripElemHeight) {
            heroUnitContainer.classList.add("img-section__bg-main--start");
            setInterval(function() {
                if (leftStripElemHeight) {
                    leftStripVal -= 15;
                    leftStripElem.style.transition = 'background-position linear 15s';
                    leftStripElem.style.backgroundPosition = '0 ' + leftStripVal + 'px';
                } 
                if (rightStripElemHeight) {
                    rightStripVal += 15;
                    rightStripElem.style.transition = 'background-position linear 15s';
                    rightStripElem.style.backgroundPosition = '0 ' + rightStripVal + 'px';
                }
            }, 500);
        }
    }

    return {
      init: init
    };

})();

window.addEventListener("load", function() {
    liveLandingPage.init();
});